<div class="text-center center-block margin-top-4-per">
	<div class="col-md-5 alert alert-danger center-block float-none">
		<h4>
			<span class="glyphicon glyphicon-ban-circle"></span> <strong>{{'g.unauthorized_access' | translate}}</strong>
		</h4>
	</div>
</div>